import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';
import { IInfrastructureProps, trackInfrastructureMapExist } from './utils';
import { InfrastructureMapContainer, InfrastructureMapTypes, MetroAndRoadsContainer } from './parts';
import { useFullscreenProps, useGeoObjectBalloon, useRouteButtonProps, useYandexMapPreview } from './hooks';
import { toGeoObjects } from './helpers';
import {
  InfrastructureLayout,
  RouteButton,
  MobilePreview,
  CloseModalButton,
  MobileModalLayout,
} from '../../components/Infrastructure';

export const MobileInfrastructureContainer: React.FC<IInfrastructureProps> = ({
  mapRef,
  isMapLoaded,
  currentTypes,
  metroStations,
  roads,
  infrastructureByYearRef,
  centeredCoordinates,
  infrastructureTypes,
  setInfrastructureType,
  handleMapLoaded,
  onGeoObjectsFetch,
  controls,
  suggestPosition,
}) => {
  const { isFullscreenOpen, handleFullscreenExit, handleFullscreenEnter } = useFullscreenProps();
  const previewSrc = useYandexMapPreview(centeredCoordinates);

  const { startBuildingRoute, isRouteMode, handleRouteModeEnter, handleRouteModeExit, handleRouteSuccess } =
    useRouteButtonProps({
      mapRef,
      centeredCoordinates,
    });
  const { onBalloonHtmlFirstFetch, onBalloonOpen } = useGeoObjectBalloon({
    infrastructureByYearRef,
    startBuildingRoute,
  });

  const handleModalExit = () => {
    handleFullscreenExit();
    handleRouteModeExit();
  };

  React.useEffect(() => {
    if (isMapLoaded) {
      const geoObjects = toGeoObjects({
        infrastructureByYear: infrastructureByYearRef.current,
        year: new Date().getFullYear(),
      });
      const geoObjectsByType = geoObjects.filter(item => currentTypes.includes(item.name));

      mapRef.current?.removeAllGeoObjects();
      mapRef.current?.addGeoObjects(geoObjectsByType);
    }
  }, [currentTypes]);

  React.useEffect(() => {
    onGeoObjectsFetch(); // Первый запрос для получения списка метро
    trackInfrastructureMapExist();
  }, []);

  return (
    <>
      <InfrastructureLayout
        isDesktop={false}
        metroAndRoads={
          <MetroAndRoadsContainer key="infrastructure-map-metro" metroStations={metroStations} roads={roads} />
        }
      >
        <MobilePreview previewSrc={previewSrc} onClick={handleFullscreenEnter} />
      </InfrastructureLayout>

      <ModalFullscreen theme="white" open={isFullscreenOpen} onClose={() => {}}>
        <MobileModalLayout>
          <InfrastructureMapContainer
            mapRef={mapRef}
            controls={controls}
            onGeoObjectsFetch={onGeoObjectsFetch}
            onBalloonHtmlFetch={onBalloonHtmlFirstFetch}
            onMapLoaded={handleMapLoaded}
            onBalloonOpen={onBalloonOpen}
            centeredCoordinates={centeredCoordinates}
            geoObjectNames={currentTypes}
            suggestPosition={suggestPosition}
            onRoutingStart={handleRouteModeEnter}
            onRoutingEnd={handleRouteModeExit}
            onRouteBuildingSuccess={handleRouteSuccess}
          />

          <CloseModalButton key="close-button" onClick={handleModalExit} />

          {!isRouteMode && (
            <>
              <RouteButton key="route-button" onClick={startBuildingRoute} fixed />

              <InfrastructureMapTypes
                key="infrastructure-map-types"
                types={infrastructureTypes}
                currentTypes={currentTypes}
                onTypesChange={setInfrastructureType}
                fixed
              />
            </>
          )}
        </MobileModalLayout>
      </ModalFullscreen>
    </>
  );
};
